export default "__VITE_ASSET__BRLNXpmu__"